import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "../../api/request";
import { getPaginationUrl } from "../../utils/constants/GetPaginationURL";

const initialState = {
  loading: false,
  resData: {
    data: [],
    meta: {},
  },
  courses: [],
  syllabuses: [],
  classes:[],
  medium:[]
};

export const getLeadsForDeo = createAsyncThunk(
  "deoSlice/getLeadsForDeo",
  async (dispatchParams) => {
    const { paginationData, fromDate, toDate } = dispatchParams;
    const paginationUrl = getPaginationUrl(paginationData);
    const res = await apiRequest({
      method: "get",
      url: `lead/getDeoLeads/${paginationUrl}&fromDate=${fromDate}&toDate=${toDate}`,
    });
    return res;
  }
);

export const getActiveCoursesForDeo = createAsyncThunk(
  "deoSlice/getActiveCoursesForDeo",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `general/courses/2?sortBy=courseName&sortDirection=asc&limit=no`,
    });
    return res;
  }
);

export const getSyllabus = createAsyncThunk(
  "deoSlice/getSyllabus",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `cr-pre-data/getSyllabus`,
    });
    return res;
  }
);

export const getClass = createAsyncThunk(
  "deoSlice/getClass",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `cr-pre-data/getClasses`,
    });
    return res;
  }
);

export const getMedium = createAsyncThunk(
  "deoSlice/getMedium",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `pre-data/getMediums`,
    });
    return res;
  }
);
export const postLeadForDeo = createAsyncThunk(
  "deoSlice/postLeadForDeo",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: `/lead/createDeoLeads`,
      data: data,
    });
    return res;
  }
);

export const postLeadForDeoSkillx = createAsyncThunk(
  "deoSlice/postLeadForDeoSkillx",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: `/lead/createDeoLeadsforskillx`,
      data: data,
    });
    return res;
  }
);

export const updateLeadForDeo = createAsyncThunk(
  "deoSlice/updateLeadForDeo",
  async (data) => {
    const res = await apiRequest({
      method: "put",
      url: `/lead/updateDeoLeads`,
      data: data,
    });
    return res;
  }
);

export const updateDeoLeadsforskillx     = createAsyncThunk(
  "deoSlice/updateDeoLeadsforskillx",
  async (data) => {
    const res = await apiRequest({
      method: "put",
      url: `/lead/updateDeoLeadsforskillx`,
      data: data,
    });
    return res;
  }
);

// export const removeLeadForDeo = createAsyncThunk(
//   "deoSlice/removeLeadForDeo",
//   async (id) => {
//     const res = await apiRequest({
//       method: "delete",
//       url: `transport//${id}`,
//     });
//     return res;
//   }
// );

const deoSlice = createSlice({
  name: "deoSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //..................GETING ALL LEAD FOR DEO................
    builder.addCase(getLeadsForDeo.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getLeadsForDeo.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        resData: {
          ...state.resData,
          data: action?.payload?.data,
          meta: action?.payload?.meta,
        },
      };
    });

    //..................GETING ALL ACTIVE COURSES................
    builder.addCase(getActiveCoursesForDeo.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getActiveCoursesForDeo.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        courses: action?.payload?.data,
      };
    });

    //..................GETING Syllabus................
    builder.addCase(getSyllabus.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getSyllabus.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        syllabuses: action?.payload?.data,
      };
    });

        //..................GETING MEDIUMS................
        builder.addCase(getMedium.pending, (state, action) => {
          return {
            ...state,
            loading: true,
          };
        });
    
        builder.addCase(getMedium.fulfilled, (state, action) => {
          return {
            ...state,
            loading: false,
            medium: action?.payload?.data?.mediums,
          };
        });
        //..................GETING CLASSES................
        builder.addCase(getClass.pending, (state, action) => {
          return {
            ...state,
            loading: true,
          };
        });
    
        builder.addCase(getClass.fulfilled, (state, action) => {
          return {
            ...state,
            loading: false,
            classes: action?.payload?.data,
          };
        });
    

    //..................POSTING  LEAD................
    builder.addCase(postLeadForDeo.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(postLeadForDeo.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });

    //..................UPDATION  LEAD................
    builder.addCase(updateLeadForDeo.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(updateLeadForDeo.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
        //..................POSTING  LEAD SKILLX................
    builder.addCase(postLeadForDeoSkillx.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(postLeadForDeoSkillx.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });

            //..................UPDATING  LEAD SKILLX................
    builder.addCase(updateDeoLeadsforskillx.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(updateDeoLeadsforskillx.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });



    // //..................DELETEING A LEAD..............
    // builder.addCase(removeLeadForDeo.pending, (state, action) => {
    //   return {
    //     ...state,
    //     loading: true,
    //   };
    // });

    // builder.addCase(removeLeadForDeo.fulfilled, (state, action) => {
    //   return {
    //     ...state,
    //     loading: false,
    //   };
    // });
  },
});

//   export const {  } = deoSlice.actions
export default deoSlice.reducer;
